import auth from './auth';
import { IS_STAGING, TABLE_SCOPE } from './constants';

class ParentPaths {
  constructor() {
    const isSignedIn = auth.isSignedIn();

    const path = window.location.pathname.replace('/index.html', ''); // Because App start from index.html

    const branchName = IS_STAGING ? path.match(/\/iap-([^/])+/i)?.[0] || '' : '';

    const pathRealm = path.replace(branchName, '').split('/')[1];
    const currentRealm = (isSignedIn ? localStorage.getItem('realm') : pathRealm) || 'nexway';
    const realm = `${branchName}/${currentRealm}`;

    this.config = {
      currentRealm,
      pathRealm,
      branchName,
    };

    this.default = `${realm}`;
    this.sso = `${realm}/sso`;
    this.recoverPassword = `${realm}/recover-password`;
    this.updatePassword = `${realm}/:token/signup`;

    this.orderlist = `${realm}/sales/orderlist`;
    this.orderCancellations = `${realm}/sales/orderCancellations`;
    this.ordersExport = {
      main: `${realm}/sales/ordersExport`,
      search: `${realm}/sales/ordersExport/ordersExportSearch`,
      list: `${realm}/sales/ordersExport/ordersExportList`,
    };
    this.marketplaceOrders = `${realm}/sales/marketplaceorders`;
    this.invoicesExport = `${realm}/sales/invoicesExport`;
    this.subscriptions = `${realm}/sales/subscriptions`;
    this.invoices = `${realm}/sales/invoices`;
    this.licenses = `${realm}/sales/licenses`;
    this.carts = `${realm}/sales/carts`;
    this.archivedOrders = `${realm}/sales/archivedorders`;

    this.stores = `${realm}/storesetup/stores`;

    this.checkoutpagebuilder = {
      main: `${realm}/storesetup/checkoutpagebuilder`,
      themesTab: `${realm}/storesetup/checkoutpagebuilder/themes`,
      layoutsTab: `${realm}/storesetup/checkoutpagebuilder/layouts`,
      fontsTab: `${realm}/storesetup/checkoutpagebuilder/fonts`,
      markupsTab: `${realm}/storesetup/checkoutpagebuilder/markups`,
    };
    this.localization = {
      main: `${realm}/storesetup/localization`,
      translationsTab: `${realm}/storesetup/localization/translations`,
      invoiceTranslationsTab: `${realm}/storesetup/localization/invoicetranslations`,
    };
    this.emailbuilder = `${realm}/storesetup/emailbuilder`;

    this.productlist = `${realm}/products/productlist`;
    this.pricemodels = {
      main: `${realm}/products/pricemodels`,
      pricesTab: `${realm}/products/pricemodels/prices`,
      pricefunctionsTab: `${realm}/products/pricemodels/pricefunctions`,
    };
    this.importExportPrices = `${realm}/products/importExportPrices`;
    this.recommendations = `${realm}/products/recommendations`;
    this.fulfillment = {
      main: `${realm}/products/fulfillment`,
      autoFulfillmentsTab: `${realm}/products/fulfillment/autoFulfillments`,
      manualFulfillmentsTab: `${realm}/products/fulfillment/manualFulfillments`,
      licenseProviderDefinitionsTab: `${realm}/products/fulfillment/licenseProviderDefinitions`,
    };
    this.customFieldsDefinition = `${realm}/products/customFieldsDefinition`;
    this.catalogs = `${realm}/products/catalogs`;
    this.discountrules = `${realm}/marketing/discountrules`;
    this.campaigns = {
      main: `${realm}/marketing/campaigns`,
      campaigns: `${realm}/marketing/campaigns/marketingCampaigns`,
      abandoned: `${realm}/marketing/campaigns/marketingAbandoned`,
      licenseExpiration: `${realm}/marketing/campaigns/licenseExpiration`,
    };
    this.endusers = `${realm}/endusers/enduserlist`;
    this.endusergroups = `${realm}/endusers/endusergroups`;
    this.resellers = `${realm}/endusers/resellers`;

    this.reports = `${realm}/reports`;

    this.users = `${realm}/settings/users`;
    this.userroles = {
      main: `${realm}/settings/userroles`,
      roles: `${realm}/settings/userroles/roles`,
      profiles: `${realm}/settings/userroles/profiles`,
      privileges: `${realm}/settings/userroles/privileges`,
    };
    this.notifications = {
      main: `${realm}/customermanagement/notifications`,
      notificationReceiversTab: `${realm}/customermanagement/notifications/notification-receivers`,
      notificationDefinitionTab: `${realm}/customermanagement/notifications/notification-definition`,
      notificationHistoryTab: `${realm}/customermanagement/notifications/notification-history`,
    };
    this.subscriptionMonitoring = `${realm}/monitoring/subscriptionMonitoring`;
    this.myaccount = `${realm}/myaccount`;
    this.crudHelper = {
      main: `${realm}/settings/crudHelper`,
      request: `${realm}/settings/crudHelper/request`,
    };
    this.serviceconfiguration = `${realm}/settings/serviceconfiguration`;

    this.customers = `${realm}/customermanagement/customerslist`;
    this.onboarding = `${realm}/customermanagement/onboarding`;
    this.remittables = `${realm}/customermanagement/remittables`;
    this.audits = `${realm}/customermanagement/audits`;

    this.referentialManager = {
      main: `${realm}/serviceconfiguration/referentialmanager`,
      currenciesTab: `${realm}/serviceconfiguration/referentialmanager/currencies`,
      localesTab: `${realm}/serviceconfiguration/referentialmanager/locales`,
      countriesTab: `${realm}/serviceconfiguration/referentialmanager/countries`,
    };
    this.subsidiaryManager = {
      main: `${realm}/serviceconfiguration/subsidiarymanager`,
      subsidiariesTab: `${realm}/serviceconfiguration/subsidiarymanager/subsidiaries`,
      subsidiaryRulesTab: `${realm}/serviceconfiguration/subsidiarymanager/subsidiaryrules`,
    };
    this.tncManager = {
      main: `${realm}/serviceconfiguration/tncmanager`,
      running: `${realm}/serviceconfiguration/tncmanager/${TABLE_SCOPE.TNC_MANAGER_RUNNING}`,
      draft: `${realm}/serviceconfiguration/tncmanager/${TABLE_SCOPE.TNC_MANAGER_DRAFT}`,
      archived: `${realm}/serviceconfiguration/tncmanager/${TABLE_SCOPE.TNC_MANAGER_ARCHIVED}`,
    };
    this.exportManagement = {
      main: `${realm}/exportManagement`,
      subscriptions: `${realm}/exportManagement/${TABLE_SCOPE.EXPORT_MANAGEMENT_SUBSCRIPTIONS}`,
      products: `${realm}/exportManagement/${TABLE_SCOPE.EXPORT_MANAGEMENT_PRODUCTS}`,
      discountRules: `${realm}/exportManagement/${TABLE_SCOPE.EXPORT_MANAGEMENT_DISCOUNT_RULES}`,
    };

    this.realms = `${realm}/realms`;
    this.productdocumentation = 'https://www.nexway.com/';
    this.apidocumentation = 'https://apidoc.nexway.store';
  }
}

const parentPaths = new ParentPaths();

export default parentPaths;
